module.exports = __webpack_public_path__ + "static/media/Moellerup_Logo.e73c8c2e.png";